(() => {
  if (window.sibrilleClearProductInitialized) return;
  window.sibrilleClearProductInitialized = true;
  const instances = new Map();

  function initialize(scope) {
    const roots = [...scope.querySelectorAll('.product-clear')];
    if (scope.matches?.('.product-clear')) roots.push(scope);
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const rail = root.querySelector('.clear-thumbnails');
      const activeMedia = new MutationObserver(() => {
        const active = rail?.querySelector('[aria-pressed="true"]');
        if (!active || !rail.clientWidth) return;
        const button = active.getBoundingClientRect();
        const bounds = rail.getBoundingClientRect();
        if (button.left < bounds.left || button.right > bounds.right) {
          rail.scrollLeft += button.left - bounds.left - (bounds.width - button.width) / 2;
        }
        if (button.top < bounds.top || button.bottom > bounds.bottom) {
          rail.scrollTop += button.top - bounds.top - (bounds.height - button.height) / 2;
        }
      });
      if (rail) activeMedia.observe(rail, { attributes: true, subtree: true, attributeFilter: ['aria-pressed'] });

      const sticky = root.querySelector('[data-clear-sticky]');
      const original = root.querySelector('[data-product-submit]');
      const purchase = root.querySelector('.buy-buttons');
      const price = root.querySelector('[data-product-price]');
      const cleanups = [() => activeMedia.disconnect()];
      if (sticky && original && purchase && 'IntersectionObserver' in window) {
        const mirror = sticky.querySelector('button');
        const stickyPrice = sticky.querySelector('[data-clear-sticky-price]');
        const sync = () => {
          mirror.innerHTML = original.innerHTML;
          mirror.disabled = original.disabled;
          mirror.setAttribute('aria-busy', String(original.getAttribute('aria-busy') === 'true'));
          if (price && stickyPrice) stickyPrice.innerHTML = price.innerHTML;
        };
        const state = new MutationObserver(sync);
        state.observe(original, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-busy'] });
        if (price) state.observe(price, { childList: true, subtree: true, characterData: true });
        let pastPurchase = false;
        let footerVisible = false;
        const visibility = () => { sticky.hidden = !pastPurchase || footerVisible; };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === purchase) pastPurchase = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            else footerVisible = entry.isIntersecting;
          });
          visibility();
        });
        observer.observe(purchase);
        const footer = document.querySelector('footer');
        if (footer) observer.observe(footer);
        mirror.addEventListener('click', () => {
          const form = document.getElementById(mirror.getAttribute('form'));
          if (!form?.checkValidity()) {
            purchase.scrollIntoView({ block: 'center', behavior: 'auto' });
          }
        });
        sync();
        cleanups.push(() => state.disconnect(), () => observer.disconnect());
      }
      instances.set(root, () => { cleanups.forEach((cleanup) => cleanup()); instances.delete(root); });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); });
  });
})();
